/** The references object of all modules needed for components initialization */
var references = {
	'search.custom': require('./search.custom'),
	'header': require('./header'),
	'header.custom': require('./header.custom'),
	'productNav': require('./../../../app_storefront_core_UI/cartridge/js/pages/product/productNav'),
	/** Components from extension cartridge */
    'global.custom': require('./global.custom')
};

/** The components initialization configuration object */
var configuration = {
	'global' : {
		'components': {
			'header' : {},
			'header.custom' : {},
			'global.custom': {},
		}
	},
	'search' : {
		'components' : {
			'search.custom' : {},
			'back-to-top' : {
				'options': {
					'showTooltip': true
				}
			},
			'refinements' : {
				'options': {
					'stickykit' : {
						'options' : {
							'inner_scrolling': true,
							'bottoming': true
						}
					}
				}
			}
		}
	},
	'product': {
		'options': {
			'showNavigation': true,
			'stickykit' : {
				'container': ''
			}
		},
		'components': {
			'carousel': {},
			'image': {
				'options': {
					'enableImgDots': false,
					'carousel': {
						'dotsContainer': '.js-pdp-thumbnails'
					}
				}
			}
		}
	}
};

module.exports = {
	'configuration' : configuration,
	'references' : references
};
